import type { SVGIconsProps } from "../type";

export function InfoIcon({ ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...restProps}
    >
      <g clipPath="url(#clip0_299_108668)">
        <path
          d="M-208 -103V-61H-256V82H229V-103H-208Z"
          stroke="#1D1F20"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M9.00025 9.42413C8.99865 9.46191 9.00479 9.49961 9.0183 9.53493C9.03181 9.57024 9.0524 9.60242 9.07881 9.62949C9.10521 9.65655 9.13687 9.67792 9.17185 9.6923C9.20682 9.70667 9.24436 9.71374 9.28217 9.71307H10.2472C10.4087 9.71307 10.5373 9.58088 10.5584 9.42062C10.6637 8.65324 11.1901 8.09408 12.1283 8.09408C12.9307 8.09408 13.6654 8.49532 13.6654 9.46039C13.6654 10.2032 13.2279 10.5448 12.5365 11.0642C11.7492 11.6362 11.1258 12.3041 11.1702 13.3885L11.1737 13.6424C11.1749 13.7191 11.2063 13.7923 11.261 13.8462C11.3157 13.9 11.3894 13.9302 11.4662 13.9301H12.4149C12.4924 13.9301 12.5668 13.8993 12.6216 13.8445C12.6765 13.7896 12.7073 13.7153 12.7073 13.6377V13.5149C12.7073 12.675 13.0267 12.4305 13.8888 11.7766C14.6012 11.235 15.344 10.6337 15.344 9.37149C15.344 7.60394 13.8514 6.75 12.2172 6.75C10.735 6.75 9.11138 7.44017 9.00025 9.42413ZM10.8216 16.1656C10.8216 16.7891 11.3188 17.25 12.0031 17.25C12.7155 17.25 13.2056 16.7891 13.2056 16.1656C13.2056 15.5199 12.7143 15.066 12.0019 15.066C11.3188 15.066 10.8216 15.5199 10.8216 16.1656Z"
          fill="#1D1F20"
        />
        <circle cx="12" cy="12" r="9" stroke="#1D1F20" strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_299_108668">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
